<template>
  <div style="min-height: 92vh">
    <ModuleHeader>Roles de sistema</ModuleHeader>
    <uv-data-table
      :config="config"
      :data="roles"
      :pageRows="15"
      @buttonClick="dtButtonClick"
    ></uv-data-table>
    <modal
      ref="modalForm"
      v-model="showModal"
      :fullscreen="true"
      :showFooter="false"
    >
      <RolForm
        :edit="editMode"
        :key="formIndex"
        @toggle="toggleModal"
        :dataEdit="editData"
        @successData="successData"
      />
    </modal>
  </div>
</template>

<style></style>

<script>
import moment from "moment";
import modal from "../MainComponents/modal.vue";
import uvDataTable from "../MainComponents/DataTable.vue";
import RolForm from "../Roles/RolesForm.vue";

export default {
  name: "CajerosCrud",
  components: {
    modal,
    uvDataTable,
    RolForm,
  },
  props: [],
  data() {
    return {
      formIndex: 0,
      formHeight: 0,
      editMode: false,
      roles: [],
      editData: {},
      showModal: false,
      config: {
        selectableRow: true,
        orderByCol: { Field: "", Type: "Asc" },
        selectConfig: {
          idRowData: "Id", // id necesario para indicar id unico del row que esta seleccionado y retornarlo en los eventos requeridos
        },
        buttons: [
          {
            text: "Agregar rol",
            icon: "lni lni-plus",
            buttonId: "addRol",
            require: false,
          },
          {
            text: "Editar rol",
            icon: "lni lni-pencil-alt",
            buttonId: "editRol",
            require: true,
          },
          {
            text: "Eliminar rol",
            icon: "lni lni-trash",
            buttonId: "eliminarRol",
            require: true,
          },
        ],
        fields: [
          {
            text: "Nombre",
            value: "NCjr",
          },
          {
            text: "Fecha de Creación",
            value: "FeCr",
            format: (row) => {
              return moment(row.FeCr).format("DD MMM YYYY hh:mm a");
            },
          },
        ],
      },
    };
  },
  methods: {
    dtButtonClick(buttonId, idSelected) {
      this.formIndex++;
      if (buttonId == "addRol") {
        this.editMode = false;
        this.editData = {};
        this.$refs.modalForm.setTitle("Agregar Rol");
        this.showModal = true;
      } else if (buttonId == "editRol") {
        const cashier = this.getCajeroById(idSelected[0]);

        this.editMode = true;
        this.editData = cashier;
        this.$pgsHelper.log(this.editData);
        this.$refs.modalForm.setTitle(`Editando Rol`);
        this.showModal = true;
      } else if (buttonId == "eliminarRol") {
        this.deleteRol(idSelected[0]);
      }
    },
    optButtonClick() {},
    successData(data, doAction) {
      if (doAction == "CREATE") {
        this.addRol(data);
      } else if (doAction == "EDIT") {
        this.editRol(data);
      }
    },
    deleteRol(Id) {
      const deletedObject = this.getCajeroById(Id) || { Id, Dpto: "ProShop" };
      let datos = { Id, Dpto: "ProShop" }; //localStorage.getItem("selectedDepartment");
      this.$swal({
        title: "¿Deseas eliminar este cajero?",
        text: "Se eliminará permanentemente",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Eliminar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("ProShop-Cajeros-deleteCajero", datos)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$pgsHelper.writeLog({
              Evento: "CAJERO_DELETE",
              Mensaje: "Cajero eliminado",
              reference: { id: Id, tp: "SEC-Cajero", al: "CAJERO" },
              data: deletedObject
            });
            this.getCashiers();
            this.$swal(
              "Cajero eliminado",
              "El cajero se eliminó correctamente",
              "success"
            );
          } else {
            this.$swal("Error deleting data", result.value.data.error, "error");
          }
        }
      });
    },
    addRol(datos) {
      this.$swal({
        title: "¿Deseas guardar la información del cajero?",
        text: "El cajero se almacenará y podrá empezar a usarse",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Guardar!",
        showLoaderOnConfirm: true,
        allowOutsideClick: false,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("ProShop-Cajeros-createCajero", datos)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$pgsHelper.log(result.value);
            const targetId = result.value.data.id || (result.value.data.data && result.value.data.data.id) || datos.Id;
            const cajeroName = datos.NCjr || datos.Nombre || "CAJERO";
            this.$pgsHelper.writeLog({
              Evento: "CAJERO_CREATE",
              Mensaje: `Cajero creado: ${cajeroName}`,
              reference: { id: targetId, tp: "SEC-Cajero", al: cajeroName },
              data: datos
            });
            this.$swal({
              title: "Guardado",
              text: "El Cajero se guardó correctamente",
              icon: "success",
            }).then(() => {
              this.getCashiers();
              this.toggleModal(false);
            });
          } else {
            this.$swal("Error saving Cajero", result.value.data.error, "error");
          }
        }
      });
    },
    editRol(datos) {
      this.$swal({
        title: "¿Deseas editar este cajero?",
        text: "Los cambios se verán reflejados inmediatamente",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Editar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("ProShop-Cajeros-updateCajero", datos)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$pgsHelper.log(result.value);
            const cajeroName = datos.NCjr || datos.Nombre || "CAJERO";
            this.$pgsHelper.writeLog({
              Evento: "CAJERO_EDIT",
              Mensaje: `Cajero editado: ${cajeroName}`,
              reference: { id: datos.Id, tp: "SEC-Cajero", al: cajeroName },
              data: datos
            });
            this.$swal({
              title: "Guardado",
              text: "El cajero se guardo correctamente",
              icon: "success",
            }).then(() => {
              this.getCashiers();
              this.toggleModal(false);
            });
          } else {
            this.$swal(
              "Error guardando Cajero",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },
    toggleModal(open) {
      this.showModal = open;
    },
    getCajeroById(code) {
      let itemIndex = this.$_.findIndex(this.roles, { Id: code });
      if (itemIndex >= 0) {
        return this.roles[itemIndex];
      }

      return false;
    },
    async getRoles() {
      this.roles = [];
    },
  },
  computed: {},
  watch: {},
  mounted() {},
  created() {
    this.getRoles();
  },
};
</script>
